import * as signalR from "@microsoft/signalr";
import protobuf from "protobufjs";
import { stringToMilliseconds } from "../time_helper.js";
import { feedServer } from "../../../config.js";
import { getParams } from "../helpers.js";
import mt5_feed from "../../_protobuf/wave.proto";

let Feed;
let connection = null;
const subscribedChannels = new Map();

const params = getParams();
const userId = params.get("user_id");
const socketURI = feedServer[params.get("identifier")];

function getChannelString(userId, symbol) {
    return `${userId}_platformChart_${symbol}`;
}


export function Initialize_proto() {
    protobuf.load(mt5_feed, function (err, root) {
        if (err) throw err;
        Feed = root.lookupType("Rate");
    });
}


export async function Connect_feed_server() {
    connection = new signalR.HubConnectionBuilder()
        .withUrl(socketURI, { withCredentials: false })
        .configureLogging(signalR.LogLevel.Information)
        .build();

    connection.on("live", (message) => {
        try {
       
            const binaryData = Uint8Array.from(atob(message), c => c.charCodeAt(0));
            const feed = Feed.decode(binaryData);      
            const tradePrice = feed.Ask;
    
            const tradeTime = Date.now();
            const channelString = getChannelString(userId, feed.ContractSymbol);

            const subscriptionItem = subscribedChannels.get(channelString);
            if (!subscriptionItem) return;

            const lastDailyBar = subscriptionItem.lastDailyBar;
            const resolution = subscriptionItem.resolution;
            const open_time = lastDailyBar?.time || tradeTime;
            const elapsed_time = stringToMilliseconds(resolution);

            let bar = lastDailyBar;
            if (tradeTime >= open_time + elapsed_time) {
                bar = {
                    open: tradePrice,
                    high: tradePrice,
                    low: tradePrice,
                    close: tradePrice,
                    time: tradeTime,
                };
            } else {
                bar = {
                    ...lastDailyBar,
                    high: Math.max(lastDailyBar.high, tradePrice),
                    low: Math.min(lastDailyBar.low, tradePrice),
                    close: tradePrice,
                };
            }

            subscriptionItem.lastDailyBar = bar;
            subscriptionItem.handlers.forEach(handler => handler.callback(bar));
        } catch (err) {
            console.error("[SignalR] Decode error:", err);
        }
    });

    connection.onreconnected(async () => {
        try {
            await connection.invoke("ValidateUser", "ForChartApi");

            const symbols = Array.from(subscribedChannels.keys())
                .map(c => c.split("_")[2])
                .filter(Boolean);

            if (symbols.length > 0) {
                for (const sym of symbols) {
                    await connection.invoke("SubscribeSymbol", sym);
                }
            }
        } catch (err) {
            console.error("[SignalR] Re-subscription failed:", err);
        }
    });

    try {
        await connection.start();
  

        await connection.invoke("ValidateUser", "ForChartApi");
        if (params.get("symbol")) {
            await connection.invoke("SubscribeSymbol", params.get("symbol"));
     
        }
    } catch (err) {
        console.error("[SignalR] Connection failed:", err);
    }
}


export function subscribeOnStream(symbolInfo, resolution, onRealtimeCallback, subscriberUID, _, lastDailyBar) {
    if (!connection || connection.state !== signalR.HubConnectionState.Connected) {
        setTimeout(() => {
            subscribeOnStream(symbolInfo, resolution, onRealtimeCallback, subscriberUID, {}, lastDailyBar);
        }, 2000);
        return;
    }

    const channelString = getChannelString(userId, symbolInfo.token_name);
    const handler = { id: subscriberUID, callback: onRealtimeCallback };

    let subscriptionItem = subscribedChannels.get(channelString);
    if (subscriptionItem) {
        subscriptionItem.handlers.push(handler);
        return;
    }

    const candleStartTime = Date.now();
    lastDailyBar = lastDailyBar || {
        time: candleStartTime,
        high: 0,
        low: 0,
        close: 0,
        open: 0,
    };

    subscriptionItem = {
        subscriberUID,
        resolution,
        lastDailyBar,
        handlers: [handler],
    };

    subscribedChannels.set(channelString, subscriptionItem);

    connection.invoke("SubscribeSymbol", symbolInfo.token_name)
        
}


export function unsubscribeFromStream(subscriberUID) {
    for (const [channelString, subscriptionItem] of subscribedChannels.entries()) {
        const handlerIndex = subscriptionItem.handlers.findIndex(handler => handler.id === subscriberUID);

        if (handlerIndex !== -1) {
            subscriptionItem.handlers.splice(handlerIndex, 1);

            if (subscriptionItem.handlers.length === 0) {
                subscribedChannels.delete(channelString);
                const symbol = channelString.split("_")[2];

                if (connection && connection.state === signalR.HubConnectionState.Connected) {
                    connection.invoke("UnsubscribeSymbol", symbol)
                        .then(() => console.log(`[SignalR] Unsubscribed from: ${symbol}`))
                        .catch((err) => console.error("[SignalR] Unsubscribe failed:", err));
                }
                break;
            }
        }
    }
}
